import { ServiceApi } from "./Api";
import md5 from "md5";

window.TokenPortal = "";

const normalizeLanguage = (language) => {
    const supportedLanguages = ['pt-BR', 'en-US', 'es-CL'];

    if (!language) return null;
    if (supportedLanguages.indexOf(language) >= 0) return language;

    const languagePrefix = language.split('-')[0];
    const languageMap = {
        pt: 'pt-BR',
        en: 'en-US',
        es: 'es-CL'
    };

    return languageMap[languagePrefix] || null;
};

const applyUserLanguage = (auth) => {
    const userLanguage = normalizeLanguage(auth && (auth.idioma || auth.Idioma)) || 'pt-BR';

    if (typeof localStorage !== 'undefined') {
        localStorage.setItem('appLang', userLanguage);
    }
};

const saveAuth = (auth) => {
    if (!auth || typeof auth !== 'object') {
        throw new Error('AUTH_INVALIDO');
    }

    sessionStorage.setItem("auth", JSON.stringify(auth));
    applyUserLanguage(auth);
};

try {
    const auth = JSON.parse(sessionStorage.getItem("auth"));
    if (window.TokenPortal === "" && auth) {
        window.TokenPortal = auth;
    }
} catch (error) { }

export class ServiceLogin {

    login(usuario, senha) {
        let name = usuario.toLowerCase();
        let cnonce = this._getNonce();
        let md5 = this._getMD5(name, senha, cnonce);
        let url = `Api/Login/PostLogin/?name=${name}&cnonce=${cnonce}&md5=${md5}&sistema=tzionMyResult`;
        return ServiceApi.post(url)
            .then(res => {
                //if (res.Irrestrito === false && res.TipoMedico === null) {
                //    alert('Usuário ou senha inválidos.');
                //    const url = window.location.href;
                //    return setTimeout(() => {
                //        window.location.assign(url);
                //    }, 500);
                //}
                saveAuth(res);
                return res;
            });
    }

    loginSolicitante(solicitanteId, senha, cnpjCliente) {
        console.log("Tentando login como Médico");
        let key = senha.toLowerCase();
        let cnonce = this._getNonce();
        let md5 = this._getMD5(solicitanteId + cnpjCliente, key, cnonce);
        let url = `Api/Login/PostLoginSolicitante/?solicitanteid=${solicitanteId}&cnonce=${cnonce}&md5=${md5}`;
        return ServiceApi.post(url)
            .then(res => {
                saveAuth(res);
                return res;
            });
    }

    loginPaciente(usuario, senha, codigoAcesso, reenviarCodigo, cnpjCliente) {
        console.log("Tentando login como Paciente");
        let prontuario = usuario.toLowerCase();
        let key = senha.toLowerCase();
        let cnonce = this._getNonce();
        let md5 = this._getMD5(prontuario + cnpjCliente, key, cnonce);
        let md52 = this._getMD5(prontuario, key, cnonce);
        codigoAcesso = codigoAcesso ? codigoAcesso : "";
        reenviarCodigo = reenviarCodigo !== undefined ? reenviarCodigo : false;
        let url = `Api/Login/PostLoginPaciente/?prontuario=${prontuario}&cnonce=${cnonce}&md5=${md5}&md52=${md52}&codigoAcesso=${codigoAcesso}&reenviarCodigo=${reenviarCodigo}`;
        return ServiceApi.post(url)
            .then(res => {
                if (res.AutenticacaoDoisFatores === false)
                    saveAuth(res);
                return res;
            });
    }

    msgEmailNaoCadastrado() {
        let url = `Api/Login/PostMsgEmailNaoCadastrado`;
        return ServiceApi.post(url)
            .then(res => {
                return res;
            });
    }

    loginConvenio(usuario, senha) {
        console.log("Tentando login como Convênio");
        let convenio = usuario.toLowerCase();
        let key = senha.toLowerCase();
        let cnonce = this._getNonce();
        let md5 = this._getMD5(convenio, key, cnonce);
        let url = `Api/Login/PostLoginConvenio/?convenio=${convenio}&cnonce=${cnonce}&md5=${md5}`;
        return ServiceApi.post(url)
            .then(res => {
                saveAuth(res);
                return res;
            });
    }

    async acessoToken(token) {
        let url = `Api/Login/PostLoginToken/?token=${token}`;

        const res = await ServiceApi.post(url);
        res['TokenPortal'] = token;
        saveAuth(res);
        return res;
    }

    lembrarSenha(id, usuario, tipo) {
        let url = `Api/Login/PostLembrarSenhaPaciente/?usuario=${usuario}&tipo=${tipo}`;
        return ServiceApi.post(url)
            .then(res => {
                //sessionStorage.setItem("auth", JSON.stringify(res));
                //return sucesso!!!
                return res;
            });
    }

    validaLicenca(body) {
        let url = `Api/Config/ValidaLicenca`;
        return ServiceApi.post(url, body)
            .then(res => {
                return res;
            })
            .catch(error => console.log(error))
    }

    static logout() {
        const logoutMsg = sessionStorage.getItem('logoutMessage'); // salva antes de limpar

        const perfil = sessionStorage.getItem('perfil');
        let role = "";

        switch (perfil) {
            case "Convenio":
                role = "convenio";
                break;
            case "Executante":
                role = "medico";
                break;
            case "Solicitante":
                role = "medicosolicitante";
                break;
            default:
                role = "";
        }

        const urlRedir = window.location.href.replace("logout", role);

        sessionStorage.removeItem("auth");
        sessionStorage.removeItem("perfil");

        if (logoutMsg) {
            sessionStorage.setItem('logoutMessage', logoutMsg); // restaura
        }

        setTimeout(() => {
            window.location = urlRedir;
        }, 500);
    }

    static isLoggedIn() {
        try {
            const auth = JSON.parse(sessionStorage.getItem("auth"));
            return !!auth && typeof auth === "object";
        } catch (error) {
            return false;
        }
    }

    static isMedico() {
        try {
            let auth = JSON.parse(sessionStorage.getItem("auth"));
            return auth.IdMedico !== 0;
        } catch (error) { }
        return false;
    }

    static isConvenio() {
        try {
            let auth = JSON.parse(sessionStorage.getItem("auth"));
            return auth.IdConvenio > 0;
        } catch (error) { }
        return false;
    }

    static isExecutante() {
        try {
            let auth = JSON.parse(sessionStorage.getItem("auth"));
            return auth.MedicoExecutanteFixo || auth.TipoMedico === "1" || auth.TipoMedico === "2";
        } catch (error) {
            return false;
        }
    }

    static getUserId() {
        try {
            let auth = JSON.parse(sessionStorage.getItem("auth"));
            return auth.Id;
        } catch (error) {
            return null;
        }
    }

    static getConvenioId() {
        try {
            let auth = JSON.parse(sessionStorage.getItem("auth"));
            return auth.IdConvenio;
        } catch (error) {
            return null;
        }
    }

    static getMedicoSolicitanteId() {
        try {
            let auth = JSON.parse(sessionStorage.getItem("auth"));
            return auth.IdMedico;
        } catch (error) {
            return null;
        }
    }

    static getUnidadesMedicoExecutante() {
        try {
            let auth = JSON.parse(sessionStorage.getItem("auth"));
            return auth.Unidades
        } catch (error) {
            return null;
        }
    }

    static getUserName() {
        try {
            let auth = JSON.parse(sessionStorage.getItem("auth"));
            return auth.Nome;
        } catch (error) {
            return null;
        }
    }

    static getUserSex() {
        try {
            let auth = JSON.parse(sessionStorage.getItem("auth"));
            return auth.Sexo;
        } catch (error) {
            return null;
        }
    }

    static getNaoPodeVisualizarPedidoSemServico() {
        // try {
        //     let auth = JSON.parse(sessionStorage.getItem("auth"));
        //     if (auth.Irrestrito)
        //         return false;
        //     if (this.isExecutante() || this.isMedico() === false) {
        //         const acoes = auth.Acoes;
        //         const find = acoes.find(obj => obj.Atributo === 'laudarPedidoSemServico');
        //         return find ? false : true;
        //     }
        //     return true;
        // } catch (error) {
        //     return true;
        // }
        return false;
        // comentado pelo motivo de que a ação laudarPedidoSemServico não pertencia ao Portal My Result, somente ao RIS.
    }

    static getNaoPodeVisualizarImagemPedidoSemServico() {
        try {
            let auth = JSON.parse(sessionStorage.getItem("auth"));
            if (auth.Irrestrito || this.isMedico() === false)
                return false;
            if (this.isMedico()) {
                const acoes = auth.Acoes;
                const find = acoes.find(obj => obj.Atributo === 'visualizarImagemPedidoSemServico');
                return find ? false : true;
            }
            return true;
        } catch (error) {
            return true;
        }
    }

    static getNaoPodeVisualizarComentarios() {
        try {
            let auth = JSON.parse(sessionStorage.getItem("auth"));
            if (auth.Irrestrito)
                return false;
            const acoes = auth.Acoes;
            const find = acoes.find(obj => obj.Atributo === 'visualizarComentario');
            return find ? false : true;
        } catch (error) {
            return null;
        }
    }

    _getNonce() {
        return (Math.random(new Date().getUTCMilliseconds())).toString().replace('.', '');
    };

    _getMD5 = function (usuario, senha, nonce) {
        return md5(usuario + nonce + senha);
    };

}
